export const WAITING_LISTS_QUERY_KEY = 'waitingLists'
